import { AbstractControl, FormGroup } from '@angular/forms';
export default class Utils {

  static getModulePath(route: string): string {

    let modulePath;

    if (route.includes('?')) {
      modulePath = route.substring(
        route.lastIndexOf('/') + 1,
        route.lastIndexOf('?'));
    } else {
      const routeSplit = route.split('/');
      modulePath = routeSplit[routeSplit.length - 1];
    }

    return modulePath;
  }

}
